import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
import { getDroppedOrSelectedFiles } from "html5-file-selector";
import DropInputComponent from "./DropInputComponent";
import DropLayoutComponent from "./DropLayoutComponent";
import {
  NOTE_IMAGES_PATH,
  STORAGE_TYPE,
} from "../../../Shared/Constants/project";

export default function FilesUploader({ files, setFiles, readOnly }) {
  const getFilesFromEvent = (e) => {
    return new Promise((resolve) => {
      getDroppedOrSelectedFiles(e).then((chosenFiles) => {
        resolve(chosenFiles.map((f) => f.fileObject));
      });
    });
  };

  const handleChangeStatus = ({ file, meta }, status) => {
    if (status === "done") {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Puedes usar readAsDataURL si necesitas Base64

      const extension = file.name.split(".").pop();
      reader.onload = () => {
        setFiles((prevFiles) => [
          ...prevFiles,
          {
            name: file.name,
            size: file.size,
            data: reader.result,
            mime_type: file.type,
            extension: extension,
            path: NOTE_IMAGES_PATH,
            storage_type: STORAGE_TYPE,
            meta: meta,
          },
        ]); // Guardamos el archivo
      };
    }
  };

  const handleDelete = (index) => {
    console.log("index", index);

    setFiles((prevFiles) =>
      prevFiles.map((file, i) =>
        i === index ? { ...file, deleted: true } : file
      )
    );
  };

  useEffect(() => {
    return () => {
      setFiles([]);
    };
  }, []);

  return (
    <>
      <Dropzone
        className="dropzone dz-clickable"
        onChangeStatus={handleChangeStatus}
        multiple={true}
        canCancel={false}
        submitButtonDisabled={true}
        InputComponent={DropInputComponent}
        inputWithFilesContent={null}
        accept=".jpg,.png,.docx,.pdf,.jpeg"
        LayoutComponent={(props) => (
          <DropLayoutComponent
            {...props}
            files={files}
            handleDelete={handleDelete}
            readOnly={readOnly}
          />
        )}
        getFilesFromEvent={getFilesFromEvent}
      />
    </>
  );
}
